export default __webpack_public_path__ + "static/media/fuuuu-23.20730321.png";